// Каталог причин отказа — GET /api/rejection-reasons (только active, authenticated).

import { apiClient } from './client';

/** Причина отказа из публичного каталога (id + имя; inactive не отдаются). */
export interface RejectionReason {
  id: string;
  name: string;
}

/** API справочника причин отказа (каталог active). */
export const rejectionReasonsApi = {
  /** GET /api/rejection-reasons → список активных причин. */
  async list(): Promise<RejectionReason[]> {
    const { data } = await apiClient.get<RejectionReason[]>('/api/rejection-reasons');
    return data;
  },
};
